import getCurrentHotel from '../../features/tour-packages/getCurrentHotel'
import { EVENT_CHAT_REQUESTED } from './EventsTracker'

/**
 * Events specific to Maldives Project(Speedboat)
 * ? NOTE: Follow below steps to add new Events
 * ? 1. Create a constant for the event with proper event name and the constant name should start with `EVENT_SB_`
 * ? 2. Add the constant to the `export default` list
 * ? 3. (Optional) Add a case inside getSpeedboatEventAttributes() if the props/attributes needs any modification
 */
const EVENT_SB_FIND_RESORTS = 'Landing Page Explore Resorts Clicked'
const EVENT_SB_BUDGET_CARD_CLICK = 'Landing Page Budget Card Clicked'
const EVENT_SB_VIEW_ALL_RESORTS_CLICK = 'Landing Page View all resorts clicked'
const EVENT_SB_MORE_RESORTS_CLICK = 'Landing Page More resorts arrow clicked'
const EVENT_SB_RESORT_LIST_ITEM_CLICK = 'Landing Page Resort Selected'
const EVENT_SB_CHECK_COOL_RESORTS = 'Landing Page Check cool resorts clicked'

const EVENT_SB_RESORT_CARD_SELECTED = 'Landing Page Resort Card Selected'
const EVENT_SB_FILTER_CHANGED = 'Listing Page Filter changed'
const EVENT_SB_UNLOCKED_DEAL = 'Listing Page Unlocked deal'
const EVENT_SB_CHANGE_FILTER_DISCLAIMER =
	'Listing Page Change Filter Disclaimer' // !TODO - remove this event
const EVENT_SB_CARD_SLIDER_IMAGES =
	'Listing Page Resort Card Slider Image changed'
const EVENT_SB_SEARCH_FILTER_CHANGE = 'Listing Page Search Filter'
const EVENT_SB_MAP_CLICKED = 'Map clicked'

const EVENT_SB_VIEW_INCLUSIONS = 'View Inclusions'

const EVENT_SB_CHANGE_ROOM = 'Change Room'
const EVENT_SB_REPLACE_ROOM = 'Replace Room'
const EVENT_SB_VIEW_ALL_ROOMS = 'View Other Rooms'
const EVENT_SB_VIEW_ROOM_DETAILS = 'View Room Details'
const EVENT_SB_RECOMMENDED_RESORTS = 'Recommended Resorts'

const EVENT_SB_CHANGE_MEAL_PLAN = 'Meal Plan Changed'
const EVENT_SB_VIEW_FLIGHT_DETAILS = 'View Flight details'

const EVENT_SB_ADD_INSURANCE = 'Add insurance plan'
const EVENT_SB_CHANGE_INSURANCE = 'Change insurance plan'
const EVENT_SB_REMOVE_INSURANCE = 'Remove insurance plan'
const EVENT_SB_REQUEST_ADDONS = 'Add Ons Requested'
const EVENT_SB_EMAIL_QUOTE_REQUESTED = 'Quote by Email Requested'

const EVENT_SB_VIEW_GALLERY = 'Gallery Clicked'
const EVENT_SB_GALLERY_TAB_CLICK = 'Gallery tab clicked'
const EVENT_SB_GALLERY_IMAGE_CHANGE = 'Gallery image changed'
const EVENT_SB_BANNER_IMAGE_CHANGE = 'Top Carousel changed'
const EVENT_SB_HOTEL_FLIGHT_TAB_CLICK = 'Hotel|Flights tab clicked'
const EVENT_SB_BAGGAGE_ADD_CLICK = 'Baggage Addition clicked'

const EVENT_SB_VIEW_MORE_REVIEWS = 'View More Reviews'
const EVENT_SB_BOOK_NOW_CLICK = 'Book Now clicked'
const EVENT_SB_CHECK_AVAILABILITY = 'check_availability'
const EVENT_SB_UPDATE_COST_CLICK = 'Resort Update Cost clicked'
const EVENT_SB_RATINGS_CLICK = 'Ratings Button clicked'
const EVENT_SB_ALTERNATE_FLIGHTS_CLICK = 'Alternate flights card clicked'
const EVENT_SB_EXPLORE_FLIGHTS_CLICK = 'Explore all flights clicked'

const EVENT_SB_RETRY_FLIGHT_CLICK = 'Retry Flight Details Clicked'
const EVENT_SB_RESORT_COSTED = 'RESORT_COSTED'

const EVENT_SB_FAQ_CARD_CLICKED = 'Faq Card Clicked'
const EVENT_SB_FAQ_VIEWALL_CLICKED = 'View All Faq clicked'
const EVENT_SB_FAQ_SCROLL = 'Faq scroll'

// Events for CRED Maldives
const EVENT_SB_CRED_CHECK_AVAILABILITY = 'CREDSB Check Availability'
const EVENT_SB_CRED_RESORT_COSTED = 'CREDSB RESORT_COSTED'
const EVENT_SB_CRED_DEALS = 'CREDSB Incredible Deals clicked'
const EVENT_SB_CRED_HELP = 'CREDSB Need Help Clicked'
const EVENT_SB_CRED_CARD = 'CREDSB Resort Description card Clicked'
const EVENT_SB_CRED_DEALS_TAB_CLICK = 'CREDSB Deals tab clicked'
const EVENT_SB_CRED_FAQ_TAB = 'CREDSB FAQs tab clicked'
const EVENT_SB_CRED_FILTER_CLICK = 'CREDSB Click on Filter'
const EVENT_SB_CRED_TC_TAB = 'CREDSB T&Cs tab clicked'
const EVENT_SB_CRED_VIDEO = 'CREDSB Video Clicked'
const EVENT_SB_CRED_FILTER_APPLY = 'CREDSB Click on Apply Filter'
const EVENT_SB_CRED_LOGO_CLICK = 'CREDSB Click on PYT Logo'

// destination Page events
const EVENT_SB_LANDING_PAGE_SEARCH =
	'Speedbali_Landing Page Search Packages clicked'
const EVENT_SB_LANDING_VIEW_ALL_CLICKED =
	'Speedbali_View all itineraries clicked'
const EVENT_SB_ITINERARY_CARD_SELECTED = 'Speedbali_Categories clicked'
const EVENT_SB_CLOSE_BTN_CLICK = 'Speedbali_Close button click'
const EVENT_SB_LISTING_LOGO_CLICK = 'Speedbali_PYT Logo clicked'
const EVENT_SB_LISTING_BREADCRUMB_CLICK = 'Speedbali_Breadcrumb click'

export default function getSpeedboatEventAttributes(
	eventName,
	props = {},
	storeData,
) {
	let resortData = {}
	try {
		const { app, maldivesData } = storeData || {}
		if (!props.resort_name) {
			if (maldivesData && maldivesData.preCostedResorts) {
				resortData.resort_id = maldivesData.preCostedResorts.resortCode
				resortData.resort_name = maldivesData.preCostedResorts.resortName
			} else if (app.itineraryInfo && Object.keys(app.itineraryInfo).length) {
				const hotelData = getCurrentHotel({
					isPreCost: false,
					itineraryInfo: app.itineraryInfo,
				})
				resortData.resort_id = hotelData.hotelCode || ''
				resortData.resort_name = hotelData.name || ''
			}
		}
	} catch (e) {
		// console.log('speedboatEvents::getSpeedboatEventAttributes', e);
	}

	switch (eventName) {
		case EVENT_SB_FIND_RESORTS:
			props = {
				...props,
				element_type: 'button',
				element_name: 'btn_landing_page_find_great_resorts',
			}
			break
		case EVENT_SB_BUDGET_CARD_CLICK:
			props = {
				...props,
				element_type: 'card',
				element_name: 'btn_landing_page_budget_card',
			}
			break
		case EVENT_SB_VIEW_ALL_RESORTS_CLICK:
			props = {
				...props,
				element_type: 'button',
				element_name: 'btn_landing_page_view_all_homepage',
			}
			break
		case EVENT_SB_RESORT_LIST_ITEM_CLICK:
			props = {
				...props,
				element_type: 'button',
				element_name: 'btn_landing_page_resort',
			}
			break
		case EVENT_SB_RESORT_CARD_SELECTED:
			props = {
				...props,
				element_type: 'card',
				element_name: 'card_resort_card_listing',
			}
			break
		case EVENT_SB_FILTER_CHANGED:
			props = {
				...props,
				element_type: 'drop_down_element',
			}
			break
		case EVENT_SB_UNLOCKED_DEAL:
			props = {
				...props,
				element_type: 'button',
			}
			break
		case EVENT_SB_CHECK_COOL_RESORTS:
			props = {
				element_type: 'button',
				element_name: 'btn_landing_page_check_cool_resorts_gcm',
				...props,
			}
			break
		case EVENT_SB_CHANGE_FILTER_DISCLAIMER:
			props = {
				element_type: 'button',
				element_name: 'btn_listing_page_change_filter_disclaimer',
				...props,
			}
			break
		case EVENT_SB_SEARCH_FILTER_CHANGE:
			props = {
				element_type: 'textbox',
				element_name: 'tb_search_box',
				...props,
			}
			break
		case EVENT_SB_VIEW_INCLUSIONS:
			props = {
				element_type: 'button',
				element_name: 'btn_view_inclusions',
				...props,
			}
			break
		case EVENT_SB_CHANGE_ROOM:
			props = {
				element_type: 'button',
				element_name: 'btn_resort_details_costed_change_room',
				...props,
			}
			break
		case EVENT_SB_REPLACE_ROOM:
			props = {
				element_type: 'button',
				element_name: 'btn_replace_room',
				...props,
			}
			break
		case EVENT_SB_VIEW_ALL_ROOMS:
			props = {
				element_type: 'button',
				element_name: 'btn_room_details',
				...props,
			}
			break
		case EVENT_SB_VIEW_ROOM_DETAILS:
			props = {
				element_type: 'button',
				element_name: 'btn_resort_details_costed_view_room_details',
				...props,
			}
			break
		case EVENT_CHAT_REQUESTED:
			props = {
				speedboat_created: 'true',
				...props,
			}
			break
		case EVENT_SB_RETRY_FLIGHT_CLICK:
			props = {
				element_type: 'button',
				element_name: 'btn_resort_details_retry_flight_details',
				...props,
			}
			break
		case EVENT_SB_CHANGE_MEAL_PLAN:
			props = {
				element_type: 'button',
				element_name: 'rb_resort_details_costed_change_meal_plan',
				...props,
			}
			break
		case EVENT_SB_VIEW_FLIGHT_DETAILS:
			props = {
				element_type: 'button',
				element_name: 'btn_resort_details_costed_view_flight_details',
				...props,
			}
			break
		case EVENT_SB_ADD_INSURANCE:
			props = {
				element_type: 'button',
				element_name: 'btn_resort_details_costed_add_insurance_plan',
				...props,
			}
			break
		case EVENT_SB_REMOVE_INSURANCE:
			props = {
				...props,
				element_type: 'button',
				element_name: 'btn_resort_details_costed_remove_insurance_plan',
			}
			break
		case EVENT_SB_REQUEST_ADDONS:
			props = {
				...props,
				element_type: 'button',
				element_name: 'btn_resort_details_costed_addons_request',
			}
			break
		case EVENT_SB_VIEW_GALLERY:
			props = {
				...props,
				element_type: 'button',
				element_name: 'btn_gallery',
			}
			break
		case EVENT_SB_LANDING_PAGE_SEARCH:
			props = {
				...props,
				element_type: 'button',
				element_name: 'speedbali_landing_page_button',
			}
			break
		case EVENT_SB_LANDING_VIEW_ALL_CLICKED:
			props = {
				...props,
				element_type: 'button',
				element_name: 'speedbali_landing_page_view_all',
			}
			break
		case EVENT_SB_ITINERARY_CARD_SELECTED:
			props = {
				...props,
				element_type: 'card',
				element_name: 'speedbali_individual_category',
			}
			break
		case EVENT_SB_CLOSE_BTN_CLICK:
			props = {
				...props,
				clicked: true,
				element_type: 'button',
				element_name: 'speedbali_listing_page_close',
			}
			break
		case EVENT_SB_LISTING_LOGO_CLICK:
			props = {
				...props,
				clicked: true,
			}
			break
		case EVENT_SB_LISTING_BREADCRUMB_CLICK:
			props = {
				...props,
				clicked: true,
			}
			break
		default:
			break
	}

	return { ...props, ...resortData }
}

export {
	EVENT_SB_FIND_RESORTS,
	EVENT_SB_BUDGET_CARD_CLICK,
	EVENT_SB_VIEW_ALL_RESORTS_CLICK,
	EVENT_SB_MORE_RESORTS_CLICK,
	EVENT_SB_RESORT_LIST_ITEM_CLICK,
	EVENT_SB_RESORT_CARD_SELECTED,
	EVENT_SB_FILTER_CHANGED,
	EVENT_SB_UNLOCKED_DEAL,
	EVENT_SB_CHECK_COOL_RESORTS,
	EVENT_SB_CHANGE_FILTER_DISCLAIMER,
	EVENT_SB_SEARCH_FILTER_CHANGE,
	EVENT_SB_CARD_SLIDER_IMAGES,
	EVENT_SB_MAP_CLICKED,
	EVENT_SB_VIEW_INCLUSIONS,
	EVENT_SB_CHANGE_ROOM,
	EVENT_SB_REPLACE_ROOM,
	EVENT_SB_VIEW_ALL_ROOMS,
	EVENT_SB_VIEW_ROOM_DETAILS,
	EVENT_CHAT_REQUESTED,
	EVENT_SB_RECOMMENDED_RESORTS,
	EVENT_SB_CHANGE_MEAL_PLAN,
	EVENT_SB_VIEW_FLIGHT_DETAILS,
	EVENT_SB_ADD_INSURANCE,
	EVENT_SB_CHANGE_INSURANCE,
	EVENT_SB_REMOVE_INSURANCE,
	EVENT_SB_REQUEST_ADDONS,
	EVENT_SB_VIEW_GALLERY,
	EVENT_SB_BOOK_NOW_CLICK,
	EVENT_SB_RETRY_FLIGHT_CLICK,
	EVENT_SB_CHECK_AVAILABILITY,
	EVENT_SB_UPDATE_COST_CLICK,
	EVENT_SB_EMAIL_QUOTE_REQUESTED,
	EVENT_SB_VIEW_MORE_REVIEWS,
	EVENT_SB_GALLERY_TAB_CLICK,
	EVENT_SB_GALLERY_IMAGE_CHANGE,
	EVENT_SB_BANNER_IMAGE_CHANGE,
	EVENT_SB_HOTEL_FLIGHT_TAB_CLICK,
	EVENT_SB_BAGGAGE_ADD_CLICK,
	EVENT_SB_RATINGS_CLICK,
	EVENT_SB_ALTERNATE_FLIGHTS_CLICK,
	EVENT_SB_EXPLORE_FLIGHTS_CLICK,
	EVENT_SB_RESORT_COSTED,
	EVENT_SB_CRED_CHECK_AVAILABILITY,
	EVENT_SB_CRED_RESORT_COSTED,
	EVENT_SB_CRED_DEALS,
	EVENT_SB_CRED_HELP,
	EVENT_SB_CRED_CARD,
	EVENT_SB_CRED_DEALS_TAB_CLICK,
	EVENT_SB_CRED_FAQ_TAB,
	EVENT_SB_CRED_FILTER_CLICK,
	EVENT_SB_CRED_TC_TAB,
	EVENT_SB_CRED_VIDEO,
	EVENT_SB_CRED_FILTER_APPLY,
	EVENT_SB_CRED_LOGO_CLICK,
	EVENT_SB_FAQ_CARD_CLICKED,
	EVENT_SB_FAQ_VIEWALL_CLICKED,
	EVENT_SB_FAQ_SCROLL,
	EVENT_SB_LANDING_PAGE_SEARCH,
	EVENT_SB_LANDING_VIEW_ALL_CLICKED,
	EVENT_SB_ITINERARY_CARD_SELECTED,
	EVENT_SB_CLOSE_BTN_CLICK,
	EVENT_SB_LISTING_LOGO_CLICK,
	EVENT_SB_LISTING_BREADCRUMB_CLICK,
}
